import { Component, Input, OnInit } from '@angular/core';
import { LandingSurface } from '../models/landing-surface.model';
import { Airport } from '../models/airport.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditRunwayComponent } from '../edit-runway/edit-runway.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { AirportService } from '../airport.service';

@Component({
  selector: 'app-runway-listing',
  templateUrl: './runway-listing.component.html',
  styleUrls: ['./runway-listing.component.scss']
})
export class RunwayListingComponent implements OnInit {
  @Input() airport: Airport;
  @Input() isIslandSource: boolean;
  isFlightDeckAdmin: boolean;
  editModeSet: boolean;

  constructor (
    private _businessManagerService: BusinessManagerService,
    private _toggleService: EditToggleService,
    private _editRunwayDialog: MatDialog,
    public _snackBar: MatSnackBar,
    private _airportService: AirportService
  ) {}

  async ngOnInit() {
    this.isFlightDeckAdmin = await this._businessManagerService.isFlightDeckAdmin();
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  /**
   * Returns runways sorted in order of descending length.
   */
  get sortedLandingSurfaces(): Array<LandingSurface> {
    return this.airport.landingSurfaces.sort((r1, r2) => {
      return r2.length - r1.length;
    });
  }

  async reloadAirport(identifier: string) {
    this.airport = await this._airportService.getAirport(identifier, true);
  }

  onRunwayDeleted(runwayId) {
    const index = this.airport.landingSurfaces.findIndex(n => n.landingSurfaceId === runwayId);
    if (index > -1) {
      this.airport.landingSurfaces.splice(index, 1);
    }
  }

  async openAddRunwayDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      airID: this.airport.airportId,
      id: null,
      isNew: false,
      windowTitle: 'Runway'
    };

    if (index == null) {
      dialogConfig.data.isNew = true;
    }

    const dialogRef = this._editRunwayDialog.open(EditRunwayComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) {
        return;
      } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) {
        return;
      }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          this.airport.landingSurfaces.push(isUpdated.runway);
          this._snackBar.open('Runway', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open(ERROR_MSG, 'Error', {
            duration: 6000
          });
        }
      }
    });
  }
}
